interface VideoPreviewProps {
  src: string;
  mimeType: string | null;
}

export function VideoPreview({ src, mimeType }: VideoPreviewProps) {
  return (
    <div
      className="flex flex-1 items-center justify-center bg-black p-4"
      data-testid="project-files-video-preview"
    >
      <video controls className="max-h-full max-w-full rounded">
        {mimeType ? <source src={src} type={mimeType} /> : <source src={src} />}
      </video>
    </div>
  );
}
